import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import { rolloverTypes } from '../../flows/shared/utils';
import DirectIcon from '../../images/direct-rollover.png';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const DirectRolloverCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      id="directRolloverCard"
      icon={DirectIcon}
      title={<div>Direct Rollover</div>}
      subtitle={
        <div>
          I have or will request a check
          <br />
          payable to T. Rowe Price
          <br />
          from my plan provider (most
          <br />
          common)
        </div>
      }
      learnMore
      learnMoreType={rolloverTypes.DIRECT}
      buttonText="Choose this option"
      buttonFunction={next(rolloverTypes.DIRECT)}
      buttonID={generateGeneralTestID('Card', 'DirectTypeButton')}
      cardID={generateGeneralTestID('Card', 'DirectTypeCard')}
    />
  );
};

export default DirectRolloverCard;
